<template>
    <div id="youtube-player">
        <div class="intro" v-html='body'></div>
        <div class="video-container">
            <iframe width="900" height="506" :src="'https://www.youtube.com/embed/'+boosterData.video_id" frameborder="0" allowfullscreen></iframe>
        </div>
        
    </div>
</template>

<script>

export default {
  name: 'YouTube',
  props: [
      'body',
      'boosterData'
  ]
}
</script>
<style>
.video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 30px; 
    height: 0; 
    overflow: hidden;
    max-width: 100%;
}

.video-container iframe,
.video-container object,
.video-container embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100%;
}
</style>
<style scoped>
.intro {
    padding: 15px 15px 30px 15px;
}
</style>